import { render, staticRenderFns } from "./PesquisarMovi.vue?vue&type=template&id=5b18724b&"
import script from "./PesquisarMovi.vue?vue&type=script&lang=js&"
export * from "./PesquisarMovi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports